import React, { useState, useEffect } from "react";
import { useQuery, useQueries } from 'react-query'
import { getResultsRSC, getResultsPhase, getUnits, getCumulativeResult } from "data/Querys"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Label from "components/general/Label"
import Loader from 'components/general/Loader'
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getPhaseRSC, getLongPhaseRSC, getEventRSC } from 'helpers/rsc'
import { filterArray } from 'helpers/utils'
import { isLiveStatus, isFinishedStatus, isMoreStartListStatus, isLessLiveStatus, isStartListStatus } from "helpers/status";
//Results
import MpnFencingBouts from 'components/sports/mpn/views/MpnFencingBouts'
import MpnFencingSummary from 'components/sports/mpn/views/MpnFencingSummary'
import MpnFencingBonus from 'components/sports/mpn/views/MpnFencingBonus'
import MpnFencingBonusSummary from "components/sports/mpn/views/MpnFencingBonusSummary";
import MpnLaser from 'components/sports/mpn/views/MpnLaser'
import MpnLaserAnalysis from "components/sports/mpn/views/MpnLaserAnalysis";
import MpnRiding from 'components/sports/mpn/views/MpnRiding'
import MpnSwimmingHeats from 'components/sports/mpn/views/MpnSwimmingHeats'
import MpnSwimmingSummary from 'components/sports/mpn/views/MpnSwimmingSummary'
import MpnPoints from 'components/sports/mpn/views/MpnPoints'
import MpnSemiFinalSummary from "components/sports/mpn/views/MpnSemiFinalSummary";
import PreviousCurrent from "components/sports/mpn/riding/PreviousCurrent";
import ProgressionRule from "components/common/ProgressionRule";
import { usePhaseFinished } from "components/sports/mpn/common/usePhaseFinished";




//Progress Bar
import LiveCheckBox from 'components/general/LiveCheckbox';
import ProgressBar from 'components/general/ProgressBar';
import NotAvailable from "components/common/NotAvailable";
import {
  isSwiming,
  isLaser,
  isFencingRR,
  isFencing,
  isEquestrian,
  isSemifinals,
  prepareRscForCumulative,
  prepareRscForCumulativeSemifinals,
  prepareRscForCumulativeFencing,
  prepareRscForPhase,
  isFinal,
  isMixedTeam,
  isTeam,
  isQualification,
  prepareRscForCumulativeTeam3
} from "components/sports/mpn/helper/MpnHelpers";
import MpnTeamEvent from "components/sports/mpn/views/MpnTeamEvent";


const MpnContext = () => {
  const { mirs_competition, mirs_discipline, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()

  const _isEG2023 = (mirs_competition === 'EG2023')
  const _event = getEventRSC(mirs_rsc)
  const _phase = getPhaseRSC(mirs_rsc);
  const _longPhase = getLongPhaseRSC(mirs_rsc);
  //const eu = useEventUnit()

  const _isLaser = isLaser(mirs_rsc);
  const _isSwiming = isSwiming(mirs_rsc);
  const _isFencingRR = isFencingRR(mirs_rsc);
  const _isEquestrian = isEquestrian(mirs_rsc);
  const _isFencingQualification = isFencing(mirs_rsc) && isQualification(mirs_rsc);
  const _isFencingBonus = isFencing(mirs_rsc) && !isQualification(mirs_rsc) && !isFencingRR(mirs_rsc);
  const _isSemifinals = isSemifinals(mirs_rsc);
  const _isFinals = isFinal(mirs_rsc);
  const _isMixed = isMixedTeam(mirs_rsc);
  const _isTeam = isTeam(mirs_rsc);

  //units of a phase
  const { data: unitsData, isError: unitsError, isLoading: unitsLoading } = useQuery(
    {
      queryKey: ['unitsPhase', mirs_competition, mirs_language, _phase],
      queryFn: getUnits,
      refetchInterval: 0,
      enabled: _isSwiming

    }
  );

  let units = (_isSwiming)
    ? unitsData?.phase?.units?.filter(item => item?.code?.slice(-12, -2) === mirs_rsc?.slice(-12, -2) && item?.scheduled === 'S')
    : []

  let queryArray = [];
  //All unit results of a phase Only for SWM
  units?.forEach((unit) => {
    queryArray.push({
      queryKey: ['resultsData', mirs_competition, unit.code, mirs_language, _longPhase],
      queryFn: getResultsRSC,
      //enabled: isSwiming
    })
  });

  const results = useQueries(queryArray);

  //Unit results
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language, _longPhase],
      queryFn: getResultsRSC,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      enabled: !_isSwiming
    }
  );

  //Phase results
  const { data: phaseData, isError: phaseIsError, isLoading: phaseIsLoading } = useQuery(
    {
      queryKey: ['resultsPhaseSummary', mirs_competition, prepareRscForPhase(mirs_rsc), mirs_language],
      queryFn: getResultsPhase,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    });

  //Cumulative results
  const { data: cumulativeData, isError: cumulativeIsError, isLoading: cumulativeIsLoading } = useQuery(
    {
      queryKey: ['resultsCumulative', mirs_competition, mirs_language, prepareRscForCumulative(mirs_rsc)],
      queryFn: getCumulativeResult,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    });

  //Cumulative semifinals summary
  const { data: cumulativeSemisData, isError: cumulativeSemisIsError, isLoading: cumulativeSemisIsLoading } = useQuery(
    {
      queryKey: ['resultsCumulativeSemis', mirs_competition, mirs_language, prepareRscForCumulativeSemifinals(mirs_rsc)],
      queryFn: getCumulativeResult,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    });

  //Cumulative fencing  
  const { data: cumulativeFencingData, isError: cumulativeFencingIsError, isLoading: cumulativeFencingIsLoading } = useQuery(
    {
      queryKey: ['resultsCumulativeSemis', mirs_competition, mirs_language, prepareRscForCumulativeFencing(mirs_rsc)],
      queryFn: getCumulativeResult,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    });

  //Cumulative team3
  const { data: cumulativeTeam3Data, isError: cumulativeTeam3IsError, isLoading: cumulativeTeam3IsLoading } = useQuery(
    {
      queryKey: ['resultsCumulativeSemis', mirs_competition, mirs_language, prepareRscForCumulativeTeam3(mirs_rsc)],
      queryFn: getCumulativeResult,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    });
  const resultStatus = data?.results?.status?.code;
  const phaseStatusSwimming = phaseData?.phaseResults && Array.isArray(phaseData?.phaseResults) && phaseData.phaseResults.length > 0 ? phaseData.phaseResults[0].status.code : '';
  const isFinishedPhaseSwimming = isFinishedStatus(phaseStatusSwimming);
  const { isPhaseFinished } = usePhaseFinished();

  //console.log("isFinishedPhaseSwimming", isFinishedPhaseSwimming)
  //console.log("isPhaseFinished", isPhaseFinished)

  const [key, setKey] = useState((isPhaseFinished && !_isFencingRR) ? `10-${mirs_rsc}` : _isLaser ? `3-${mirs_rsc}` : _isSwiming && isFinishedPhaseSwimming ? `6-${mirs_rsc}` : _isSwiming ? `5-${mirs_rsc}` : _isEquestrian ? `7-${mirs_rsc}` : _isFencingBonus ? `9-${mirs_rsc}` : _isFencingRR && !isStartListStatus(resultStatus) ? `2-${mirs_rsc}` : `1-${mirs_rsc}`);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    //Tab logic for Fencing Ranking Round
    if (_isFencingRR || _isFencingQualification) {
      setKey(`2-${mirs_rsc}`)
    }

    //Tab logic for Fencing Bonus Round
    if (_isFencingBonus) {
      setKey(`8-${mirs_rsc}`)
    }

    //Tab logic for Modern Pentathlon Points
    if (isPhaseFinished && !_isFencingRR) {
      setKey(`10-${mirs_rsc}`)
    }

    //Tab logic for Swiming
    if (_isSwiming && !isPhaseFinished && isFinishedPhaseSwimming) {
      setKey(`6-${mirs_rsc}`)
    } else if (_isSwiming && isPhaseFinished) {
      setKey(`10-${mirs_rsc}`)
    } else if (_isSwiming) {
      setKey(`5-${mirs_rsc}`)
    }

    //Tab logic for TeamEvent
    if (_isTeam && !_isMixed) {
      setKey(`11-${mirs_rsc}`)
    }


  }, [resultStatus, isPhaseFinished, isFinishedPhaseSwimming])


  if (isError || phaseIsError || unitsError || cumulativeIsError || cumulativeSemisIsError || cumulativeFencingIsError || cumulativeTeam3IsError || results?.some(result => result.isError)) { return <NotAvailable />; }
  if (isLoading || phaseIsLoading || unitsLoading || cumulativeIsLoading || cumulativeSemisIsLoading || cumulativeFencingIsLoading || cumulativeTeam3IsLoading || results?.some(result => result.isLoading)) { return <Loader />; }

  const _isFinishedCum = cumulativeSemisData?.cumulativeResults?.status?.code?.includes('OFFICIAL')

  let intermediates
  if (mirs_rsc.slice(-4) === 'LR--') {
    intermediates = filterArray(data?.config?.extendedConfig, { type: ['LR'], code: ['INTERMEDIATE'] });
  }

  const getProgessBarConfiguration = () => {
    let config = {
      distance: {
        unit: 'm',
        exceptions: [
          { pos: 'S', label: 'HeaderStart' },

        ]
      },
      hideProgress: false,
      hidePassed: true,
      style: 'box-data',
      numColVisibles: { sm: 1, lg: 3 }
    }
    config.breakpoints = {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: intermediates?.length < 7 ? intermediates?.length : 6 },
    }
    return config;
  }

  const progressBarConfig = getProgessBarConfiguration();
  const hasProgressBar = false;//isMoreStartListStatus(resultStatus) && _isLaser
  const _isStartListStatus = isLessLiveStatus(resultStatus);
  const haveSwimmingSummaryData = phaseData?.phaseResults && Array.isArray(phaseData?.phaseResults) && phaseData.phaseResults.length > 0 && phaseData.phaseResults[0].items
  const isLive = isLiveStatus(resultStatus);
  const _isFinished = isFinishedStatus(resultStatus);
  const dataHeader = unitsData?.phase?.description

  return (
    <>
      <PageHeader data={data} title={!data?.results ? dataHeader : undefined} />
      <div className='mirs-page-container'>
        {data?.progressBar && hasProgressBar && key === `3-${mirs_rsc}` && <ProgressBar id={`mirs-progressbar-${mirs_rsc}`} data={data.progressBar} config={progressBarConfig} dinamic={key === `3-${mirs_rsc}`} />}
        {data?.progressBar && hasProgressBar && !_isFinished && key === `3-${mirs_rsc}` && <LiveCheckBox id={`mirs-livecheckbox-${mirs_rsc}`} />}
        {key === `7-${mirs_rsc}` && <PreviousCurrentRiding data={data} rsc={mirs_rsc} />}
        {key === `10-${mirs_rsc}` && <ProgressionRule key="progress-component" data={data?.config} filter={{ type: ['QUALIFICATION'], code: ['QUAL_RULE'] }} itemData={'value'} />}

        <Tabs
          id="mirs-navsport"
          className="mb-3 mirs-tab-result"
          activeKey={key}
          onSelect={(k) => setKey(k)}
        >
          {(_isFencingRR || _isFencingQualification) && <Tab eventKey={`2-${mirs_rsc}`} title={<Label data={_isFencingQualification ? "HeaderResults" : "HeaderFencingRRSummary"} />} disabled={_isFencingRR && _isStartListStatus} tabClassName={'mirs-break-line text-center'}>
            <MpnFencingSummary data={data} />
          </Tab>}

          {_isLaser && _isMixed == _isTeam && <Tab eventKey={`3-${mirs_rsc}`} title={<Label data="LaserRunResults" />} tabClassName={'mirs-break-line text-center text-nowrap'} >
            <MpnLaser data={data} />
          </Tab>}

          {_isSwiming && <Tab eventKey={`5-${mirs_rsc}`} title={<Label data="Heats" />} tabClassName={'mirs-break-line text-center'}>
            <Heats results={results} phaseData={phaseData} />
          </Tab>}

          {_isSwiming && <Tab eventKey={`6-${mirs_rsc}`} title={<Label data="HeaderSwimmingSummary" />} disabled={(haveSwimmingSummaryData && !isFinishedPhaseSwimming)} tabClassName={'mirs-break-line text-center text-nowrap'}>
            <MpnSwimmingSummary data={phaseData} />
          </Tab>}

          {_isEquestrian && <Tab eventKey={`7-${mirs_rsc}`} title={<Label data="Riding" />} tabClassName={'mirs-break-line text-center'} >
            <MpnRiding data={data} />
          </Tab>}

          {_isFencingBonus && <Tab eventKey={`8-${mirs_rsc}`} title={<Label data="HeaderBouts" />} tabClassName={'mirs-break-line text-center'}>
            <MpnFencingBonus data={data} />
          </Tab>}

          {!_isFencingRR && !(_isTeam && !_isMixed) && <Tab eventKey={`10-${mirs_rsc}`} title={<Label data="ModernPentathlonPoints" />} tabClassName={'mirs-break-line text-center text-nowrap'} disabled={_isEquestrian && _isStartListStatus}>
            <MpnPoints data={cumulativeData} />""
          </Tab>}

          {_isLaser && _isFinals && !_isMixed && <Tab eventKey={`11-${mirs_rsc}`} title={<Label data="LinkTeamResults" />} tabClassName={'mirs-break-line text-center'} >
            <MpnTeamEvent data={cumulativeTeam3Data} />
          </Tab>}

        </Tabs>
      </div>
    </>
  );
};

export default MpnContext;


function Heats({ results, phaseData }) {
  var found = 0
  results.forEach((r, i) => {
    if (r?.data?.results)
      found++
  })

  return (
    <>
      {(found === 0)
        ? <NotAvailable />
        : results.map((res, index) => {
          return <MpnSwimmingHeats key={`results-component-${index}`} data={res.data} phaseData={phaseData} />
        })
      }
    </>
  )
}


const PreviousCurrentRiding = ({ data, rsc }) => {

  const currentId = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'CURRENT')?.ei_value;
  const current = data?.results?.items?.find(i => i?.participant?.code === currentId);

  const previousId = data?.results?.extendedInfos?.find(ei => ei?.ei_code === 'LAST_COMP')?.ei_value;
  const previous = data?.results?.items?.find(i => i?.participant?.code === previousId);
  return (
    <>
      {
        isEquestrian(rsc) &&
        isLiveStatus(data?.results?.status?.code) &&
        <PreviousCurrent current={current} previous={previous} />
      }
    </>
  )

}